<template>
	<div>
		<div class="data6">
			<div class="data6Left" :style="{
				paddingLeft:bj+'px'
			}">
				<div class="data6LeftTil">
					{{list.data.menuTitle}}
				</div>
				<div class="data6LeftBox">
					<div class="data6LeftFor" v-for="(item,index) in list.data.content" :key="index">
						<div class="data6LeftForImg">
							<img :src="item.cover" />
						</div>
						<div class="data6LeftForName">
							{{item.title}}
						</div>
						<div class="data6LeftForCen">
							<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="data6Right">
				<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`" >
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in list.data.cover" :key="index">
							<img :src="item" v-if="!list.data.type||list.data.type==1" :style="{
								height:list.data.height+'px'
							}" />
							<!-- <video :src="item" v-else :autoplay="true" muted loop :style="{
								height:list.data.height+'px'
							}"></video> -->
							<template v-else>
								<template v-if="headerShow">
									<video :src="item" :autoplay="true" muted loop :style="{
								height:list.data.height+'px'
							}" webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
								</template>
								<template v-else>
									<video :src="item"  muted loop :style="{
								height:list.data.height+'px'
							}" webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
								</template>
							</template>
						</div>
					</div>
					<template v-if="!headerShow">
						<div class="swiper-hexin-prev"  :style="{
							left:`30px`,
							display:qhShow?activeIndex==0?'none':'block':'none'
						}" @click="prev()">
							<img src="@/assets/index/hxz.png" />
						</div>
						<div class="swiper-hexin-next" :style="{
							right:`30px`,
							display:qhShow?activeIndex==list.data.cover.length-1?'none':'block':'none'
						}" @click="next()">
							<img src="@/assets/index/hxy.png" />
						</div>
					</template>
				</div>
				<!-- <img :src="list.data.cover[0]" /> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props:{
				list:{
					typeof:Object,
					default:{}
				}
			},
		data() {
			return {
				bj:'',
				qhShow:true,
				activeIndex: 0,
				// byzlList: [{
				// 		img: require('@/assets/product/page9/jhms.png'),
				// 		name: '全新人机交互模式',
				// 		cen: '- 可触摸液晶屏界面加上常用功能快捷按钮设计- 在有双重保障的同时增强了系统可用性和使用友好性'
				// 	},
				// 	{
				// 		img: require('@/assets/product/page9/yjcb.png'),
				// 		name: '一键插拔',
				// 		cen: '- 内镜一键连接处理器，无需繁琐的传统电缆线连接- 极大提高内镜医护人员的工作效率'
				// 	},
				// 	{
				// 		img: require('@/assets/product/page9/znqd.png'),
				// 		name: '智能启动',
				// 		cen: '- 系统主动识别内镜类型，并自动开启常用功能- 内镜拔出后，自动关闭气泵及光源，提升工作效率'
				// 	},
				// ]
			}
		},
		mounted() {
			let t = this;
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			this.getWidth()
			let name='.swiper-data2-banner'+this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				allowTouchMove: this.list.data.cover.length > 1 ? true : false,
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				// 自动播放
				autoplay: false,
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},
			
				},
			});
			this.$nextTick(function(){
				if(this.list.data.cover.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			getWidth(){
				console.log(document.body.clientWidth,window.screen.availWidth)
				let width=''
				if(document.body.clientWidth>1200){
					 width=document.body.clientWidth - 1200;
				}else{
					 width=0;
				}
				this.$nextTick(function(){
					this.bj=width/2
				})
			},
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.cover.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.cover.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data6 {
		display: flex;
		padding-bottom: 150px;

		.data6Left {
			flex: 1;
			padding-left: 200px;

			.data6LeftTil {
				font-size: 45px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #000000;
				margin-bottom: 70px;
			}

			.data6LeftBox {
				display: flex;
				flex-wrap: wrap;
				width: 100%;

				.data6LeftFor {
					width: calc(49% - 40px);
					padding: 0 20px;
					margin-bottom: 70px;

					.data6LeftForImg {
						margin-bottom: 40px;

						img {
							width: 70px;
							height: 70px;
						}
					}

					.data6LeftForName {
						margin-bottom: 32px;
						font-size: 26px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #000000;
					}

					.data6LeftForCen {
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 300;
						color: #000000;
						white-space: pre-line;
					}
				}
			}
		}

		.data6Right {
			width: 50%;
			// background: #000000;
			img {
				width: 100%;
				height: 600px;
				object-fit: cover;
			}
		}
	}
	.swiper-data2-banner {
		overflow: hidden;
		width: 100%;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
	}
	
	.swiper-slide {
		position: relative;
		width: 100%;
		img {
			width: 100%;
			height: 600px;
			object-fit: cover;
		}
	
		video {
			width: 100%;
			height: 600px;
			object-fit: contain;
		}
	}
	@media screen and (max-width:1200px) {
		.data6{
			padding:0 30px 30px !important;
			flex-wrap: wrap;
			.data6Left{
				min-width: 100% !important;
				padding-left: 0  !important;
				.data6LeftTil{
					font-size: 24px !important;
					margin-bottom: 20px !important;
				}
				.data6LeftFor{
					margin-bottom: 20px !important;
					.data6LeftForImg {
						width: 40px;
						height: 40px;
						margin-bottom: 20px !important;
							
						img {
							width: 40px !important;
							height: 40px !important;
							object-fit: cover;
						}
					}
							
					.data6LeftForName {
						font-size: 18px !important;
						margin-bottom: 20px !important;
					}
							
					.data6LeftForCen {
						font-size: 14px !important;
					}
				}
				
			}
			.data6Right{
				width: 100% !important;
				.swiper-slide{
					width:100% !important;
					video{
						height: auto !important;
					}
				}
				img{
					height: auto !important;
				}
			}
			
		}
		.swiper-data2-banner{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
	}
</style>